import { uniq } from 'ramda';
import type { Displays_Screen } from 'c-sdk';

/** Every resolution the screens need, once each, as "WxH". */
export const uniqueScreenResolutionLabels = (screens: Displays_Screen[] | undefined): string[] =>
    uniq(
        (screens ?? []).flatMap(
            screen => screen?.resolutions?.map(r => `${r.width}x${r.height}`) ?? [],
        ),
    );
